import { render, staticRenderFns } from "./social.vue?vue&type=template&id=5ed2b86d&scoped=true"
import script from "./social.vue?vue&type=script&lang=js"
export * from "./social.vue?vue&type=script&lang=js"
import style0 from "./social.vue?vue&type=style&index=0&id=5ed2b86d&prod&scoped=true&lang=css"
import style1 from "./social.vue?vue&type=style&index=1&id=5ed2b86d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed2b86d",
  null
  
)

export default component.exports